import React, { FC, useEffect, useState } from 'react';
import { UpdateProfileContainer } from './updateProfileScreen.styles';
import { TextInputField } from '@sainsburys-tech/luna-react';
import { Button } from '@sainsburys-tech/luna-react';
import { PanelActions } from 'src/components/PanelActions/panelActions.styles';
import { ViewAdDetailsContainer } from './viewAdDetailsScreen.styles';
import { ProgressSpinner } from '@sainsburys-tech/luna-react';

interface IViewAdDetailsScreen {
  handleClose: () => void;
  heading: string;
  providerId?: string;
}
export const ViewAdDetailsScreen: FC<IViewAdDetailsScreen> = ({
  handleClose,
  heading,
  providerId,
}) => {
  const [accountEnabled, setAccountEnabled] = useState<boolean | null>(null);
  const [lastSignInDateTime, setLastSignInDateTime] = useState<string | null>(
    null,
  );
  const [lastSuccessfulSignInDateTime, setLastSuccessfulSignInDateTime] =
    useState<string | null>(null);
  const [externalUserState, setExternalUserState] = useState<string | null>(
    null,
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [resyncMessage, setResyncMessage] = useState<string | null>(null);
  const [activateADMessage, setActivateADMessage] = useState<string | null>(null);

  const formatDate = (date?: string) => {
    return date
      ? new Intl.DateTimeFormat('en-GB', {
          dateStyle: 'full',
          timeStyle: 'long',
        }).format(new Date(date))
      : null;
  };

  const fetchAdDetails = async (guid: string) => {
    const params = new URLSearchParams({
      guid: guid,
    });
    try {
      const response = await fetch(`/profile-service/user?${params}`, {
        method: 'GET',
        mode: 'cors',
      });
      if (response.status === 500) {

        setResyncMessage(
          'User not found in AD, resync the profile and try again.',
        );
        setLoading(false);
      } else {
        const data = await response.json();
        const { accountEnabled, signInActivity, externalUserState } = data;
        accountEnabled
          ? setAccountEnabled(data.accountEnabled)
          : setActivateADMessage(
              'User not activated in AD, activate the user and try again.',
            );
        signInActivity?.lastSignInDateTime &&
          setLastSignInDateTime(signInActivity.lastSignInDateTime);
        signInActivity?.lastSuccessfulSignInDateTime &&
          setLastSuccessfulSignInDateTime(
            data.signInActivity?.lastSuccessfulSignInDateTime,
          );
        externalUserState && setExternalUserState(data.externalUserState);
        setLoading(false);
      }
    } catch (err) {
      console.error('Error fetching AD details:', err);
    }
  };
  useEffect(() => {
    if (!providerId) return;
    fetchAdDetails(providerId);
  }, []);

  return (
    <>
      <ViewAdDetailsContainer>
        <>
          <div className='panel-heading'>
            <h3>{heading}</h3>
          </div>
          {loading ? (
            <div className="center-panel">
              <ProgressSpinner />
            </div>
          ) : (
            <>
              {!activateADMessage && !resyncMessage && (
                <div className='panel-body'>
                  <TextInputField
                    label='Account enabled'
                    value={accountEnabled ? 'Yes' : 'No'}
                  />
                  <TextInputField
                    label='Last attempted log in'
                    value={
                      (lastSignInDateTime && formatDate(lastSignInDateTime)) ||
                      ''
                    }
                  />
                  <TextInputField
                    label='Last successful log in'
                    value={
                      (lastSuccessfulSignInDateTime &&
                        formatDate(lastSuccessfulSignInDateTime)) ||
                      ''
                    }
                  />
                  {externalUserState && (
                    <TextInputField
                      label='External user state'
                      value={externalUserState || ''}
                    />
                  )}
                </div>
              )} {activateADMessage || resyncMessage && (
                <div className='panel-body'>
                  <p>{activateADMessage || resyncMessage}</p>
                </div>
              )} 
            </>
          )}
        </>
      </ViewAdDetailsContainer>
      <PanelActions>
        <Button type='button' onClick={handleClose} variant='outlined'>
          Close
        </Button>
      </PanelActions>
    </>
  );
};
